// applies variable updates returned by the script execution worker
export const applyVariableDiff = (
  initialVariables,
  updatedVariables,
  setEndpointVariables,
  endpointId,
  testCaseId,
  addVariableMutation,
) => {
  if (!updatedVariables) return initialVariables;

  const hasChanges = JSON.stringify(initialVariables) !== JSON.stringify(updatedVariables);
  if (!hasChanges) return initialVariables;

  setEndpointVariables(updatedVariables);

  if (testCaseId) {
    addVariableMutation.mutate({
      endpointId: endpointId || null,
      testCaseId: testCaseId,
      variables: updatedVariables,
    });
  }

  return updatedVariables;
};

// applies environment updates returned by the script execution worker
export const applyEnvironmentDiff = (
  initialEnvironmentMap,
  updatedEnvironmentMap,
  environmentVariablesArray,
  selectedEnvironmentId,
  addEnvironmentVariableMutation,
  deleteEnvironmentVariableMutation,
  GLOBAL_OPTION,
  NONE_OPTION,
) => {
  if (!updatedEnvironmentMap) return;

  const validEnvironmentSelected =
    selectedEnvironmentId &&
    selectedEnvironmentId !== GLOBAL_OPTION &&
    selectedEnvironmentId !== NONE_OPTION;

  // process additions and updates
  Object.entries(updatedEnvironmentMap).forEach(([key, value]) => {
    if (initialEnvironmentMap[key] !== value) {
      if (validEnvironmentSelected) {
        addEnvironmentVariableMutation.mutate({
          variableData: { environmentId: selectedEnvironmentId, variable: key, value },
        });
      }
    }
  });

  // process deletions
  Object.keys(initialEnvironmentMap).forEach((key) => {
    if (!(key in updatedEnvironmentMap)) {
      if (validEnvironmentSelected) {
        const existingVariable = environmentVariablesArray.find((v) => v.variable === key);
        if (existingVariable) {
          deleteEnvironmentVariableMutation.mutate({ variableId: existingVariable.id });
        }
      }
    }
  });
};

// applies request context modifications (URL, headers, body, queryParams)
// returned by the script execution worker
export const applyRequestModifications = (modifiedRequestData, scriptModifiedContext) => {
  if (scriptModifiedContext && scriptModifiedContext.request) {
    const modReq = scriptModifiedContext.request;
    if (modReq.headers) modifiedRequestData.headers = modReq.headers;
    if (modReq.body !== undefined) modifiedRequestData.body = modReq.body;
    if (modReq.url) modifiedRequestData.url = modReq.url;
    if (modReq.queryParams) modifiedRequestData.queryParams = modReq.queryParams;
  }
  return modifiedRequestData;
};
